import React from "react";

import { Link } from "react-router-dom";

import ServiceIcon from "Components/ServiceIcon";
import * as Code from "ds/Code";
import useDecodedParams from "Hooks/useDecodedParams";
import useSelectorWithUrlParams from "Hooks/useSelectorWithUrlParams";
import { environmentSelector } from "Reducers/environment";
import { ServiceRelationshipsType } from "Reducers/environment/service";
import { gitProjectSelector } from "Reducers/project/project";

import * as S from "./Relationships.styles";

export interface RelationshipProps {
  relationship: ServiceRelationshipsType;
}

const Relationship = ({ relationship }: RelationshipProps) => {
  const { projectId, organizationId, environmentId } = useDecodedParams<{
    projectId: string;
    organizationId: string;
    environmentId: string;
  }>();

  const project = useSelectorWithUrlParams(gitProjectSelector);
  const environment = useSelectorWithUrlParams(environmentSelector);
  const sshUrls = environment?.getSshUrls() || {};
  const ssh = sshUrls[relationship.name];
  const runtime = relationship.runtime.split(":");
  const icon = relationship.runtime.split(":")[0];
  const relationUrl = `/${organizationId}/${projectId}/${encodeURIComponent(environmentId)}/services/${relationship.name}`;
  const displayCodeBlock = project?.region && environment?.machine_name && ssh;

  return (
    <>
      <S.Cell>
        <Link to={relationUrl}>
          <S.Title>
            <S.RowLeftLayout>
              <ServiceIcon iconName={icon} alt={`${icon}-icon`} />
              {relationship.name}
            </S.RowLeftLayout>
          </S.Title>
        </Link>
      </S.Cell>
      <S.Cell>{`${runtime[0]} ${runtime[1]}`}</S.Cell>
      {displayCodeBlock ? (
        <Code.Block isCopyable singleLine id={ssh}>
          {ssh}
        </Code.Block>
      ) : (
        <div />
      )}
    </>
  );
};

export default Relationship;
